import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const blueColor = '#3b82f6'; // Tailwind's blue-500

  return (
    <section
      id="hero"
      className="relative w-full h-[75vh] bg-cover bg-center flex items-center justify-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7)',
      }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="container mx-auto text-center text-white px-4 relative z-10">
        <motion.h1
          className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 sm:mb-6"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          Welcome to{' '}
          <span className="text-blue-500" style={{ color: blueColor }}>
            Our App
          </span>
        </motion.h1>
        <motion.p
          className="text-lg sm:text-xl mb-6 sm:mb-8 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut", delay: 0.2 }}
        >
          Simplifying your experience with elegance and performance.
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          
          <a href="#features"
            className="bg-blue-500 hover:bg-blue-600 text-white py-3 px-6 rounded-full font-semibold text-lg transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 inline-block"
          >
            Get Started
          </a>
        </motion.div>
      </div>
      
      {/* Optional: Add a subtle indicator that there's more content below */}
      <motion.div 
        className="absolute bottom-6 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{ duration: 1.5, delay: 1, repeat: Infinity }}
      >
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </motion.div>
    </section>
  );
};

export default Hero;